export function PageMetaQuery(url: string) {
  return /* GraphQL */ `
  query pageQuery {
    pageCollection(where: { url: "${url}" }, limit: 1) {
      items {
        seoTitle
        seoDescription
        ogImage {
          url
          width
          height
          title
        }
        ldJsonSchema
        theme
        sys {
          id
        }
        navigationMode
      }
    }
  }
  `;
}
